import { NgModule, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanvasComponent } from './canvas/canvas.component';
import { registerCoupledWindowConfigurations } from '@icc/coupled-window/types';

export function registerCoupledWindowConfigurator() {
    return () => {
        registerCoupledWindowConfigurations();
    };
}
import { ConfiguratorUiModule } from '@icc/configurator/ui';
import { SharedModule } from '@icc/configurator/shared';
import { ConfiguratorPagesModule } from '@icc/configurator/pages';
import { SillsModalComponent } from './sills-modal/sills-modal.component';
export { SillsModalComponent };

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ConfiguratorUiModule,
        ConfiguratorPagesModule,
    ],
    declarations: [CanvasComponent, SillsModalComponent],
    exports: [CanvasComponent, SillsModalComponent],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = (registerCoupledWindowConfigurator)();
            return initializerFn();
        })
    ],
})
export class CoupledWindowConfiguratorModule {}
